import React, { FC } from "react";
import { BurnAssessment } from "../assessment/BurnAssessment";
import { Tooltip } from "@mui/material";
import LocalFireDepartmentRoundedIcon from "@mui/icons-material/LocalFireDepartmentRounded";
import { useTranslation } from "react-i18next";
import { BurnAssessmentIcon } from "../assessment/BurnAssessmentIcon";

export interface BurnStartQualityAdornmentProps {
  startQuality: BurnAssessment;
  chimneyFire: boolean;
}

export const BurnStartQualityAdornment: FC<BurnStartQualityAdornmentProps> = (
  props
) => {
  const { t } = useTranslation("firefly-shared-ts-domain");
  if (props.chimneyFire) {
    return (
      <Tooltip title={t("Temperature Alarm")} arrow placement={"top-start"}>
        <LocalFireDepartmentRoundedIcon sx={{ color: "text.secondary" }} />
      </Tooltip>
    );
  } else {
    const burnAssessmentText = t(`BurnAssessment.${props.startQuality}`);
    return (
      <Tooltip
        title={`${t("Assessment of burn start")}: ${burnAssessmentText}`}
        arrow
        placement={"top-start"}
      >
        <BurnAssessmentIcon value={props.startQuality} />
      </Tooltip>
    );
  }
};
